<template>
  <div>
    <AppMenu />

    <!-- m="4" md="4" lg="4" -->
    <div tabindex="0">
      <v-row no-gutters>
        <v-col cols="12">
          <BaseBreadcrumb :title="$t(title)">
            <template v-slot:actions>
              <div class="d-flex justify-end">
                <v-btn small outlined color="primary" class="mr-2" title="Volver a consultar" @click="search(form, 1)">
                  <v-icon small left>mdi-restart</v-icon>Actualizar
                </v-btn>
              </div>
            </template>
          </BaseBreadcrumb>
          <PanelFiltros
            :form="form"
            :cargando="loading"
            :labels="{ local_reference: 'Referencia', order_status: 'Estado', date_order: 'Fecha' }"
            @filtrar="search(form, 1)"
          >
            <ng-text v-model="form.local_reference" label="Consecutivo, referencia o mesa"></ng-text>
            <v-select
              v-model="form.order_status"
              :items="estadosFiltro"
              label="Estado"
              outlined
              dense
              clearable
              hide-details
              class="mb-3"
            ></v-select>
            <ng-date-range v-model="form.date_order" label="date_order"></ng-date-range>
          </PanelFiltros>
          <v-card class="mt-3 mx-3">
            <SkeletonLista v-if="loading && (!items || !items.length)" :columnas="6" :tarjetas="$store.getters.mobile" />
            <div v-else-if="$store.getters.mobile">
              <v-list class="list-mobile">
                <v-list-item v-if="!items || !items.length">
                  <v-list-item-content><v-list-item-title class="text-center">No hay órdenes con esos filtros</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div v-for="item in items" :key="item.id">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("reference") }}:
                          </span>
                          <span>{{ item.local_reference }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("date") }}:
                          </span>
                          <span>{{ item.date_order }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >Consecutivo:
                          </span>
                          <span>{{ item.consecutive_order_text || item.name_table || "—" }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("total") }}:
                          </span>
                          <span>{{
                            $filters.currency(item.total_to_pay, 0)
                          }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("balance") }}:
                          </span>
                          <span>{{
                            $filters.currency(item.total_to_pay, 0)
                          }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("tip") }}:
                          </span>
                          <span>{{
                            $filters.currency(item.price_tip, 0)
                          }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >Vendedor:
                          </span>
                          <span>{{ item?.data_seller?.name }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"
                            >{{ $t("order_status") }}:
                          </span>
                          <span>{{ $t(item.order_status) }}</span>
                        </div>
                      </v-list-item-title>
                      <v-list-item-title>
                        <div
                          class="d-flex justify-space-between list-mobile-field"
                        >
                          <span v-if="title" class="title-td"></span>
                          <span>
                            <v-menu offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon>mdi-arrow-down</v-icon>
                                  {{ $t("actions") }}
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item class="d-flex flex-column">
                                  <v-btn
                                    block
                                    small
                                    class="mb-1"
                                    :title="$t('print_order')"
                                    elevation="1"
                                    @click="executePrintOrder(item)"
                                  >
                                    <v-icon>mdi-printer</v-icon>
                                    {{ $t("print_order") }}
                                  </v-btn>
                                </v-list-item>
                                <v-list-item class="d-flex flex-column ">
                                  <v-btn
                                    block
                                    small
                                    class="mb-1"
                                    elevation="1"
                                    v-if="item.consecutive_order"
                                    :title="$t('returns')"
                                    @click="openModalCreditNote(item)"
                                  >
                                    <v-icon>mdi-file-document-outline</v-icon>
                                    {{ $t("returns") }}
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="item.id"></v-divider>
                </div>
              </v-list>
            </div>
            <div v-else class="px-2">
              <v-data-table
                mobile-breakpoint="300"
                :options.sync="options"
                :disable-filtering="true"
                v-on:update:page="changePage"
                v-on:update:sort-desc="changeOrder"
                v-on:update:items-per-page="changeItemsPerPage"
                :headers="headers"
                :items="items"
                :server-items-length="total"
                :loading="loading"
                class="listing-app"
                item-key="id"
                :show-expand="false"
                :expanded.sync="expanded"
                :footer-props="{
                  'items-per-page-options': options.itemsPerPageOptions,
                  'items-per-page-text': $t('list.items_per_page'),
                }"
              >
                <!-- eslint-disable-next-line -->
                <template v-slot:header.id>
                  <span class="field-uuid">{{ $t("id") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.consecutive_order_text>
                  <span class="field-reference">{{
                    $t("consecutive_order_text")
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.local_reference>
                  <span class="field-string">{{ $t("reference") }}</span>
                </template>

                <!-- eslint-disable-next-line -->
                <template v-slot:header.date_order>
                  <span class="field-reference">{{ $t("date_order") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.total_to_pay>
                  <span class="field-string">{{ $t("total") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.price_tip>
                  <span class="field-string">{{ $t("tip") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.data_seller>
                  <span class="field-string">{{ $t("Seller") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header.order_status>
                  <span class="field-string">{{ $t("order_status") }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:header._actions>
                  <span class="field-string">{{ $t("actions") }}</span>
                </template>

                <!-- eslint-disable-next-line -->
                <template v-slot:item.id="{ item }">
                  <span class="field-uuid">{{ item.id }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.consecutive_order_text="{ item }">
                  <span class="field-string">{{
                    item.consecutive_order_text
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.local_reference="{ item }">
                  <span class="field-string">{{ item.local_reference }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.date_order="{ item }">
                  <span class="field-date">{{
                    $filters.datetime(item.date_order)
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.total_to_pay="{ item }">
                  <span class="field-string">{{
                    $filters.currency(item.total_to_pay, 0)
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.price_tip="{ item }">
                  <span class="field-string">{{
                    $filters.currency(item.price_tip, 0)
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.data_seller="{ item }">
                  <span class="field-string">{{
                    item?.data_seller?.name
                  }}</span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.order_status="{ item }">
                  <span class="field-string">
                    <v-chip
                      small
                      dark
                      :color="setStatusColor(item.order_status)"
                    >
                      {{ $t(item.order_status) }}
                    </v-chip>
                  </span>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item._actions="{ item }">
                  <div class="d-flex flex-wrap justify-end py-1">
                    <v-btn small outlined color="primary" class="mr-1" :title="$t('print_order')" @click="executePrintOrder(item)">
                      <v-icon small left>mdi-printer</v-icon>Imprimir
                    </v-btn>
                    <v-btn small outlined color="primary" v-if="item.consecutive_order" :title="$t('returns')" @click="openModalCreditNote(item)">
                      <v-icon small left>mdi-file-document-outline</v-icon>Devoluciones
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </div>
            <div
              v-if="$store.getters.mobile && hayMas"
              class="d-flex justify-center pt-1 pb-2"
            >
              <v-btn
                small
                color="primary"
                @click="loadMore"
                :loading="loadingMore"
                >{{ $t("view_more_with_points") }}</v-btn
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <CreditNoteModal ref="creditNoteModal" />
  </div>
</template>
<script>
import AppMenu from "../menu/AppMenu.vue";

import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
import MixinModalDynamic from "@/components/mixins/MixinModalDynamic";
import CreditNoteModal from "./CreditNoteComponents/CreditNoteModal.vue";

export default {
  name: "ServerOrders",
  mixins: [NextMixinListPage, MixinActions, MixinModalDynamic],
  components: { AppMenu, CreditNoteModal },
  data: () => ({
    app_version: null,
    title: "Ordenes Servidor",
    form: {},
    url: "api/v1/order",
    pathBase: "/pos/server-orders",
    options: {
      page: 1,
      itemsPerPage: 10,
      itemsPerPageOptions: [10, 25, 50, 100],
    },
    headers: [
      { title: "consecutive_order_text", value: "consecutive_order_text" },
      { title: "local_reference", value: "local_reference" },
      { title: "date_order", value: "date_order" },
      { title: "total_to_pay", value: "total_to_pay" },
      { title: "price_tip", value: "price_tip" },
      { title: "data_seller", value: "data_seller", sortable: false },
      { title: "order_status", value: "order_status" },
      { title: "_actions", value: "_actions", sortable: false },
    ],
    estadosFiltro: [
      { text: "Cerradas", value: "closed" },
      { text: "Anuladas", value: "annulled" },
      { text: "En preparación", value: "preparing" },
      { text: "Listas", value: "prepared" },
      { text: "Pendientes", value: "pending" },
    ],
    tmplShow: `<v-dialog v-model="dialog" width="500" style="background-color:white">
                <v-card class="pa-3">
                <v-row no-gutters>

                    <v-col cols="12" class=" list-mobile-field" > {{$t('product_type')}}:  {{$filters.name(item.product_type)}}</v-col>
                    <v-col cols="12" class=" list-mobile-field" > {{$t('reference')}}:  {{item.reference}}</v-col>
                    <v-col cols="12" class=" list-mobile-field" > {{$t('name')}}:  {{item.name}}</v-col>
                    <v-col cols="12" class=" list-mobile-field" > {{$t('category')}}:  {{$filters.name(item.category)}}</v-col>
                    <v-col cols="12" class=" list-mobile-field" > {{$t('image')}}:  {{item.image}}</v-col>
                    <v-col cols="12" class=" list-mobile-field" > {{$t('active')}}:  {{$filters.boolean(item.active)}}</v-col>
                </v-row>
                <v-card-actions class="d-flex justify-end">
                    <v-btn outlined color="primary" @click="close" small> {{$t('Cerrar')}} </v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>`,
    //cart: null
    //priceList:
  }),

  created() {
    // Una sucursal guardada con los filtros de antes sale como chip vacío; ahora viaja aparte.
    if (this.form) {
      delete this.form.subsidiary;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    openHelp() {
      window.open(process.env.VUE_APP_BASECONFIG_URL_HELP, "_blank");
    },
    launchMenuPos(evt) {
      return false;
    },
    async load() {
      setTimeout(async () => {
        this.app_version = process.env.VUE_APP_BASECONFIG_APP_VERSION;
        await this.$db.load();
        const installed = await this.$db.itsInstalled();
        if (!installed) {
          this.openInstall = true;
        } else {
          this.installedEvent();
        }
      }, 50);
    },
    async installedEvent() {
      this.$pos.priceLists = await this.$db.getPriceLists();
      this.installed = true;
      this.openInstall = false;
      this.key++;
      this.keyReloadProducts++;
    },
    toogleDrawer() {
      this.$store.commit("toggle");
    },
    // La sucursal va aparte del formulario: si entraba en `form` quedaba guardada con los filtros
    // y salía como un chip «Sucursal:» vacío que no significa nada para quien mira la lista.
    getParamsDefault(params) {
      const installation = this.$store.getters.installation;
      return installation ? { subsidiary: { id: installation.subsidiary_id } } : {};
    },

    setStatusColor(status) {
      switch (status) {
        case "create":
          return "primary";
          break;
        case "pending":
          return "warning";
          break;
        case "received":
        case "closed":
          return "success";
        case "annulled":
          return "error";
        case "preparing":
        case "prepared":
          return "info";
          break;
        default:
          return "error";
          break;
      }
    },
    executeAnulate(item) {},
    executePrintOrder(item) {
      this.$http
        .get("api/v1/order/" + item.id, {}, true, false)
        .then((response) => {
          if (response && response.success && response.item) {
            return this.$pos.printOrderServer(response.item);
          }
          this.avisarErrorImpresion((response && (response.msg || response.message)) || "No se pudo cargar la orden para imprimirla.");
        })
        .catch((e) => {
          console.error(e);
          this.avisarErrorImpresion("No se pudo imprimir la orden: " + (e && e.message ? e.message : e));
        });
    },
    avisarErrorImpresion(mensaje) {
      if (this.$http && typeof this.$http.showError === "function") {
        this.$http.showError(mensaje);
      } else {
        alert(mensaje);
      }
    },
    openModalCreditNote(item) {
      this.$refs.creditNoteModal.renderItem(item);
    },
    async search(params, page) {
      let installation = this.$store.getters.installation;
      if (!installation) {
        setTimeout(() => {
          this.search(params, page);
        }, 1500);
        return;
      }
      NextMixinListPage.methods.search.call(this, params, page);
    },
  },
};
</script>
